var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPasswordVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 87",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 63",
    d: "M0 0h24v24H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 10",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(10 10)",
    style: {
      stroke: "#9e9e9e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 64",
    d: "M22 12q-4 7-10 7T2 12q4-7 10-7t10 7",
    style: {
      stroke: "#9e9e9e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordVisible);
export default __webpack_public_path__ + "static/media/icon-password-visible.fc3a3906.svg";
export { ForwardRef as ReactComponent };